import React from 'react';
import { connect } from 'react-redux';

import { conversationMembersSelector } from '../selectors/conversation';
import { isVwrFeatureEnabled } from '../util';
import { RootState } from '../store';

import styles from './MembersList.module.css';

export function MembersList({ members }: { members?: { displayName: string }[] }) {
  if (!members || members.length < 3 || isVwrFeatureEnabled) {
    return null;
  }

  const displayNames = [];
  for (const member of members) {
    const displayName = member ? member.displayName : 'Unknown';
    displayNames.push(displayName);
  }

  const membersList = members.length + ' Members: ' + displayNames.join(', ');

  return <div className={styles.members}>{membersList}</div>;
}

const mapState = (state: RootState) => ({
  members: conversationMembersSelector(state),
});

export default connect(mapState)(MembersList);
